export default __webpack_public_path__ + "static/media/banner3.9808ea72.jpg";